import type { CategoryLabelDescriptionAndIcon, Plugin } from '@base/types';

export const PLUGIN_CATEGORIES: Record<number, string> = {
  0: 'Blockchain & Web3',
  1: 'Content & Media',
  2: 'Development & Platform',
  3: 'Integration & Services',
};

export const PLUGIN_NAMES = [
  // Blockchain & Web3
  '@elizaos/plugin-0g',
  '@elizaos/plugin-abstract',
  '@elizaos/plugin-akash',
  '@elizaos/plugin-allora',
  '@elizaos/plugin-anyone',
  '@elizaos/plugin-aptos',
  '@elizaos/plugin-arthera',
  '@elizaos/plugin-asterai',
  '@elizaos/plugin-autonome',
  '@elizaos/plugin-avail',
  '@elizaos/plugin-avalanche',
  '@elizaos/plugin-binance',
  '@elizaos/plugin-coinbase',
  '@elizaos/plugin-coingecko',
  '@elizaos/plugin-coinmarketcap',
  '@elizaos/plugin-conflux',
  '@elizaos/plugin-cosmos',
  '@elizaos/plugin-cronoszkevm',
  '@elizaos/plugin-depin',
  '@elizaos/plugin-evm',
  '@elizaos/plugin-flow',
  '@elizaos/plugin-fuel',
  '@elizaos/plugin-genlayer',
  '@elizaos/plugin-hyperliquid',
  '@elizaos/plugin-icp',
  '@elizaos/plugin-multiversx',
  '@elizaos/plugin-near',
  '@elizaos/plugin-rabbi-trader',
  '@elizaos/plugin-solana',
  '@elizaos/plugin-spheron',
  '@elizaos/plugin-starknet',
  '@elizaos/plugin-sui',
  '@elizaos/plugin-ton',
  '@elizaos/plugin-zksync-era',
  '@elizaos/plugin-solana-agentkit',
  '@elizaos/plugin-movement',
  '@elizaos/plugin-quai',
  '@elizaos/plugin-trikon',
  '@elizaos/plugin-pyth-data',
  '@elizaos/plugin-massa',
  '@elizaos/plugin-injective',
  '@elizaos/plugin-arbitrage',
  '@elizaos/plugin-ferepro',
  '@elizaos/plugin-holdstation',
  '@elizaos/plugin-zilliqa',
  '@elizaos/plugin-zerion',
  '@elizaos/plugin-squid-router',
  '@elizaos/plugin-solana-v2',
  '@elizaos/plugin-sei',
  '@elizaos/plugin-quick-intel',
  '@elizaos/plugin-omniflix',
  '@elizaos/plugin-moralis',
  '@elizaos/plugin-mina',
  '@elizaos/plugin-lightning',
  '@elizaos/plugin-iq6900',
  '@elizaos/plugin-initia',
  '@elizaos/plugin-gelato',
  '@elizaos/plugin-form',
  '@elizaos/plugin-ethstorage',
  '@elizaos/plugin-edwin',
  '@elizaos/plugin-dexscreener',
  '@elizaos/plugin-desk-exchange',
  '@elizaos/plugin-cronos',
  '@elizaos/plugin-chainbase',
  '@elizaos/plugin-bnb',
  '@elizaos/plugin-b2',
  '@elizaos/plugin-ankr',
  '@elizaos/plugin-0x',
  '@elizaos/plugin-router-nitro',
  '@elizaos/plugin-thirdweb',
  '@elizaos/plugin-stargaze',
  '@elizaos/plugin-apro',
  '@elizaos/plugin-lens-network',

  // Content & Media
  '@elizaos/plugin-3d-generation',
  '@elizaos/plugin-story',
  '@elizaos/plugin-image-generation',
  '@elizaos/plugin-nft-generation',
  '@elizaos/plugin-video-generation',
  '@elizaos/plugin-tts',
  '@elizaos/plugin-gitbook',
  '@elizaos/plugin-obsidian',
  '@elizaos/plugin-udio',
  '@elizaos/plugin-suno',
  '@elizaos/plugin-nft-collections',
  '@elizaos/plugin-imgflip',
  '@elizaos/plugin-speech-tts',
  '@elizaos/plugin-letzai',
  '@elizaos/plugin-video',
  '@elizaos/plugin-pdf',
  '@elizaos/plugin-image',

  // Development & Platform
  '@elizaos/plugin-bootstrap',
  '@elizaos/plugin-goat',
  '@elizaos/plugin-intiface',
  '@elizaos/plugin-node',
  '@elizaos/plugin-tee',
  '@elizaos/plugin-tee-log',
  '@elizaos/plugin-tee-marlin',
  '@elizaos/plugin-trustdb',
  '@elizaos/plugin-goplus',
  '@elizaos/plugin-opacity',
  '@elizaos/plugin-hyperbolic',
  '@elizaos/plugin-tee-verifiable-log',
  '@elizaos/plugin-openai',
  '@elizaos/plugin-nvidia-nim',
  '@elizaos/plugin-mind-network',
  '@elizaos/plugin-lit',
  '@elizaos/plugin-gitcoin-passport',
  '@elizaos/plugin-dkg',
  '@elizaos/plugin-devin',
  '@elizaos/plugin-dcap',
  '@elizaos/plugin-bittensor',
  '@elizaos/plugin-agentkit',
  '@elizaos/plugin-sgx',
  '@elizaos/plugin-irys',
  '@elizaos/plugin-llama',
  '@elizaos/plugin-browser',
  '@elizaos/plugin-aws-s3',
  '@elizaos/plugin-primus',
  '@elizaos/plugin-di',

  // Integration & Services
  '@elizaos/plugin-twitter',
  '@elizaos/plugin-web-search',
  '@elizaos/plugin-whatsapp',
  '@elizaos/plugin-echochambers',
  '@elizaos/plugin-open-weather',
  '@elizaos/plugin-giphy',
  '@elizaos/plugin-news',
  '@elizaos/plugin-football',
  '@elizaos/plugin-email-automation',
  '@elizaos/plugin-email',
] as const;

export const PLUGINS_MAP: Record<Plugin, CategoryLabelDescriptionAndIcon> = {
  // Blockchain & Web3
  '@elizaos/plugin-0g': {
    category: 0,
    label: '0g',
    description:
      'A plugin for storing data using the 0G protocol within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-akash': {
    category: 0,
    label: 'Akash',
    description: 'Akash Network Plugin for Eliza.',
    icon: '',
  },
  '@elizaos/plugin-allora': {
    category: 0,
    label: 'Allora',
    description:
      'Seamlessly empowers Eliza agents with real-time, advanced, self-improving AI inferences from the Allora Network.',
    icon: '',
  },
  '@elizaos/plugin-anyone': {
    category: 0,
    label: 'Anyone',
    description:
      'A plugin for integrating Anyone protocol proxy services into Eliza agents.',
    icon: '',
  },
  '@elizaos/plugin-arthera': {
    category: 0,
    label: 'Arthera',
    description:
      'This plugin provides actions and providers for interacting with Arthera.',
    icon: '',
  },
  '@elizaos/plugin-asterai': {
    category: 0,
    label: 'asterai',
    description: 'A plugin for interacting with asterai plugins and agents.',
    icon: '',
  },
  '@elizaos/plugin-autonome': {
    category: 0,
    label: 'Autonome',
    description:
      'A plugin that enables launching new Eliza agents through the Autonome platform.',
    icon: '',
  },
  '@elizaos/plugin-avail': {
    category: 0,
    label: 'Avail',
    description:
      'This is a plugin for using Eliza to interact with the Avail DA network.',
    icon: '',
  },
  '@elizaos/plugin-abstract': {
    category: 0,
    label: 'Abstract',
    description:
      'A plugin for interacting with the Abstract blockchain network within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-depin': {
    category: 0,
    label: 'DePIN',
    description:
      'This plugin empowers the Eliza Agent Framework with Perception and Action capabilities via DePINs, bridging the digital intelligence of AI with the physical world.',
    icon: '',
  },
  '@elizaos/plugin-genlayer': {
    category: 0,
    label: 'GenLayer',
    description:
      'A plugin for interacting with the GenLayer protocol, enabling contract deployment, interactions, and transaction management.',
    icon: '',
  },
  '@elizaos/plugin-spheron': {
    category: 0,
    label: 'Spheron',
    description:
      'This plugin integrates the Spheron Protocol SDK into the Eliza ecosystem, providing functionality for managing deployments, escrow operations, and lease management.',
    icon: '',
  },
  '@elizaos/plugin-aptos': {
    category: 0,
    label: 'Aptos',
    description:
      'A plugin for interacting with the Aptos blockchain network within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-avalanche': {
    category: 0,
    label: 'Avalanche',
    description:
      'A plugin for interacting with the Avalanche blockchain network within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-binance': {
    category: 0,
    label: 'Binance platform',
    description:
      'This plugin enables Eliza to interact with the Binance cryptocurrency exchange, providing capabilities for checking prices, executing trades, and managing spot wallet balances.',
    icon: '',
  },
  '@elizaos/plugin-coinbase': {
    category: 0,
    label: 'Coinbase',
    description: `A comprehensive Coinbase integration plugin for ElizaOS that provides access to Coinbase's various APIs and services.`,
    icon: '',
  },
  '@elizaos/plugin-coingecko': {
    category: 0,
    label: 'CoinGecko',
    description:
      'A plugin for fetching cryptocurrency price data from the CoinGecko API.',
    icon: '',
  },
  '@elizaos/plugin-coinmarketcap': {
    category: 0,
    label: 'CoinMarketCap',
    description:
      'A plugin for Eliza that enables cryptocurrency price checking using the CoinMarketCap API.',
    icon: '',
  },
  '@elizaos/plugin-conflux': {
    category: 0,
    label: 'Conflux',
    description:
      'A plugin for interacting with the Conflux blockchain network within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-cosmos': {
    category: 0,
    label: 'Cosmos ecosystem',
    description:
      'This plugin provides actions and utilities for interacting with Cosmos-compatible blockchains.',
    icon: '',
  },
  '@elizaos/plugin-cronoszkevm': {
    category: 0,
    label: 'Cronos zkEVM',
    description:
      'A plugin for interacting with the Cronos zkEVM network within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-evm': {
    category: 0,
    label: 'EVM',
    description:
      'This plugin provides actions and providers for interacting with EVM-compatible chains.',
    icon: '',
  },
  '@elizaos/plugin-flow': {
    category: 0,
    label: 'Flow',
    description:
      'A plugin for interacting with the Flow blockchain within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-fuel': {
    category: 0,
    label: 'Fuel',
    description:
      'A plugin for interacting with the Fuel blockchain within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-icp': {
    category: 0,
    label: 'Internet Computer',
    description: 'Internet Computer Protocol (ICP) plugin for Eliza OS.',
    icon: '',
  },
  '@elizaos/plugin-hyperliquid': {
    category: 0,
    label: 'Hyperliquid',
    description:
      'This plugin enables interaction with the Hyperliquid DEX through Eliza, providing spot trading capabilities.',
    icon: '',
  },
  '@elizaos/plugin-multiversx': {
    category: 0,
    label: 'MultiversX',
    description:
      'MultiversX blockchain integration plugin for Eliza OS that enables token management and transfers.',
    icon: '',
  },
  '@elizaos/plugin-near': {
    category: 0,
    label: 'NEAR',
    description:
      'NEAR Protocol integration plugin for Eliza OS that enables token management, transfers, and swaps using Ref Finance.',
    icon: '',
  },
  '@elizaos/plugin-rabbi-trader': {
    category: 0,
    label: 'Rabbi Trader',
    description: 'Plugin for Rabbi Trader.',
    icon: '',
  },
  '@elizaos/plugin-solana': {
    category: 0,
    label: 'Solana',
    description:
      'Core Solana blockchain plugin for Eliza OS that provides essential services and actions for token operations, trading, and DeFi integrations.',
    icon: '',
  },
  '@elizaos/plugin-starknet': {
    category: 0,
    label: 'Starknet',
    description:
      'Core Starknet blockchain plugin for Eliza OS that provides essential services and actions for token operations, trading, and DeFi integrations.',
    icon: '',
  },

  '@elizaos/plugin-sui': {
    category: 0,
    label: 'Sui',
    description:
      'Core Sui blockchain plugin for Eliza OS that provides essential services and actions for token operations and wallet management.',
    icon: '',
  },
  '@elizaos/plugin-ton': {
    category: 0,
    label: 'TON',
    description:
      'A plugin for handling TON (Telegram Open Network) blockchain operations, providing wallet management and transfer capabilities.',
    icon: '',
  },
  '@elizaos/plugin-zksync-era': {
    category: 0,
    label: 'zkSync Era',
    description:
      'A plugin for integrating ZKSync Era blockchain operations with your application, providing token transfer capabilities and transaction management.',
    icon: '',
  },

  '@elizaos/plugin-solana-agentkit': {
    category: 0,
    label: 'Solana Agentkit',
    description:
      'Solana Agentkit plugin which comes with create/deploy token actions',
    icon: '',
  },
  '@elizaos/plugin-movement': {
    category: 0,
    label: 'Movement',
    description:
      'A plugin for transacting on Movement Network Testnet and Mainnet',
    icon: '',
  },
  '@elizaos/plugin-quai': {
    category: 0,
    label: 'Quai',
    description:
      'Enables native token transfers and interactions with the Quai blockchain for Eliza OS.',
    icon: '',
  },
  '@elizaos/plugin-trikon': {
    category: 0,
    label: 'Trikon',
    description:
      'A Proof of Concept (POC) implementation for Trikon token transfers within the Eliza ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-pyth-data': {
    category: 0,
    label: 'Pyth Data',
    description:
      'Integrates with Pyth Network for real-time price feeds and data streams across multiple asset classes.',
    icon: '',
  },
  '@elizaos/plugin-massa': {
    category: 0,
    label: 'Massa',
    description:
      'This plugin serves as the foundation for all interactions with the Massa ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-injective': {
    category: 0,
    label: 'Injective',
    description:
      'Provides comprehensive interaction with the Injective blockchain through module-based action creation.',
    icon: '',
  },
  '@elizaos/plugin-arbitrage': {
    category: 0,
    label: 'Arbitrage',
    description:
      'Identifies and executes cryptocurrency arbitrage opportunities across multiple exchanges.',
    icon: '',
  },
  '@elizaos/plugin-ferepro': {
    category: 0,
    label: 'FerePro',
    description:
      'A plugin for WebSocket communication with FerePro API, offering AI-driven market insights in the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-holdstation': {
    category: 0,
    label: 'Holdstation',
    description:
      'Enables token swapping on Holdstation DEX with support for ZKsync Era and upcoming Berachain.',
    icon: '',
  },
  '@elizaos/plugin-zilliqa': {
    category: 0,
    label: 'Zilliqa',
    description:
      'Integrates Zilliqa blockchain capabilities through the GOAT framework for wallet and transaction functionality.',
    icon: '',
  },
  '@elizaos/plugin-zerion': {
    category: 0,
    label: 'Zerion',
    description:
      'A plugin for Eliza that fetches real-time wallet portfolio and position data using the Zerion API.',
    icon: '',
  },
  '@elizaos/plugin-squid-router': {
    category: 0,
    label: 'Squid Router',
    description:
      'Enables cross-chain token swaps between blockchains using the Squid Router protocol.',
    icon: '',
  },
  '@elizaos/plugin-solana-v2': {
    category: 0,
    label: 'Solana v2',
    description:
      'Leverages @solana/web3.js v2 for modern, efficient Solana integrations with liquidity position management.',
    icon: '',
  },
  '@elizaos/plugin-sei': {
    category: 0,
    label: 'Sei',
    description:
      'Enables Eliza agents to perform actions on the Sei blockchain, including transferring SEI tokens and querying wallet balances.',
    icon: '',
  },
  '@elizaos/plugin-quick-intel': {
    category: 0,
    label: 'Quick Intel',
    description:
      'Performs token security audits and market analysis with support for multiple chains and address formats.',
    icon: '',
  },
  '@elizaos/plugin-omniflix': {
    category: 0,
    label: 'OmniFlix',
    description:
      'A plugin for ElizaOS that enables interaction with the OmniFlix Network blockchain, supporting bank, staking, and governance operations.',
    icon: '',
  },
  '@elizaos/plugin-moralis': {
    category: 0,
    label: 'Moralis',
    description:
      'Fetches real-time DeFi data including trading pairs, statistics, and price history through Moralis APIs.',
    icon: '',
  },
  '@elizaos/plugin-mina': {
    category: 0,
    label: 'Mina',
    description:
      'Enables Mina blockchain interactions for token transfers, wallet management, and balance queries.',
    icon: '',
  },
  '@elizaos/plugin-lightning': {
    category: 0,
    label: 'Lightning',
    description:
      'Enables Lightning Network integration for creating invoices and making off-chain Bitcoin payments.',
    icon: '',
  },
  '@elizaos/plugin-iq6900': {
    category: 0,
    label: 'IQ6900',
    description:
      "Provides blockchain inscription functionality through IQ6900's Code-In standard for permanent agent storage.",
    icon: '',
  },
  '@elizaos/plugin-initia': {
    category: 0,
    label: 'Initia',
    description:
      'Enables token transfers on the Initia blockchain with support for INIT token transactions.',
    icon: '',
  },
  '@elizaos/plugin-gelato': {
    category: 0,
    label: 'Gelato',
    description:
      'Enables smart contract interactions via Gelato Relay supporting both ERC2771 and non-ERC2771 calls on EVM chains.',
    icon: '',
  },
  '@elizaos/plugin-form': {
    category: 0,
    label: 'Form',
    description:
      'Integrates Form chain capabilities for curves-based token economics with ERC20 conversion and management.',
    icon: '',
  },
  '@elizaos/plugin-ethstorage': {
    category: 0,
    label: 'EthStorage',
    description:
      'Enables interaction with EthStorage decentralized storage network for data submission and token transfers.',
    icon: '',
  },
  '@elizaos/plugin-edwin': {
    category: 0,
    label: 'Edwin',
    description:
      'A plugin for Eliza that enables interaction with Edwin tools for decentralized finance (DeFi) operations.',
    icon: '',
  },
  '@elizaos/plugin-dexscreener': {
    category: 0,
    label: 'DexScreener',
    description:
      "Accesses DexScreener's token data for price information and market trends across multiple blockchains.",
    icon: '',
  },
  '@elizaos/plugin-desk-exchange': {
    category: 0,
    label: 'DESK Exchange',
    description:
      'Integrates with DESK Exchange for perpetual futures trading with support for market and limit orders.',
    icon: '',
  },
  '@elizaos/plugin-cronos': {
    category: 0,
    label: 'Cronos',
    description:
      'Extends EVM plugin functionality for Cronos blockchain with native CRO token support and wallet operations.',
    icon: '',
  },
  '@elizaos/plugin-chainbase': {
    category: 0,
    label: 'Chainbase',
    description:
      'Bridges on-chain data with AI agents, enabling natural language interactions with blockchain data across networks.',
    icon: '',
  },
  '@elizaos/plugin-bnb': {
    category: 0,
    label: 'BNB',
    description:
      'Enables interactions with BNB Chain ecosystem including BNB Smart Chain, opBNB, and BNB Greenfield networks.',
    icon: '',
  },
  '@elizaos/plugin-b2': {
    category: 0,
    label: 'B2',
    description:
      'Enables token transfers on the B2-Network blockchain with support for B2-BTC and ERC20 tokens.',
    icon: '',
  },
  '@elizaos/plugin-ankr': {
    category: 0,
    label: 'Ankr',
    description:
      'Provides blockchain data query interfaces for wallet information, NFT operations, and token analytics.',
    icon: '',
  },
  '@elizaos/plugin-0x': {
    category: 0,
    label: '0x',
    description:
      'Enables token swaps through 0x Protocol across multiple EVM blockchains with optimized routing and liquidity aggregation.',
    icon: '',
  },
  '@elizaos/plugin-router-nitro': {
    category: 0,
    label: 'Router Nitro',
    description:
      'The Router Nitro plugin enables seamless cross-chain token transfers and wallet management across blockchains.',
    icon: '',
  },
  '@elizaos/plugin-thirdweb': {
    category: 0,
    label: 'Thirdweb',
    description:
      "This plugin provides access to thirdweb's Nebula AI for analyzing smart contracts and blockchain data.",
    icon: '',
  },
  '@elizaos/plugin-stargaze': {
    category: 0,
    label: 'Stargaze',
    description: 'A plugin for fetching NFT data from the Stargaze API.',
    icon: '',
  },
  '@elizaos/plugin-apro': {
    category: 0,
    label: 'Apro',
    description:
      'Enables agent operations, data verification, and price queries with secure on-chain validation features.',
    icon: '',
  },
  '@elizaos/plugin-lens-network': {
    category: 0,
    label: 'Lens Network',
    description:
      'Facilitates token transfers on the Abstract blockchain testnet for both native and ERC20 tokens.',
    icon: '',
  },

  // Content & Media
  '@elizaos/plugin-story': {
    category: 1,
    label: 'Story',
    description: 'Plugin for Story',
    icon: '',
  },
  '@elizaos/plugin-obsidian': {
    category: 1,
    label: 'Obsidian',
    description:
      'An Obsidian plugin for ELIZA OS that provides seamless integration with Obsidian vaults, enabling powerful file and note management capabilities.',
    icon: '',
  },
  '@elizaos/plugin-image-generation': {
    category: 1,
    label: 'Image Generation',
    description:
      'A plugin designed for generating and managing images, providing features like image manipulation, storage integration, and optimized handling for various use cases.',
    icon: '',
  },
  '@elizaos/plugin-3d-generation': {
    category: 1,
    label: '3D Generation',
    description:
      'A plugin for generating 3D models using the FAL.ai API within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-tts': {
    category: 1,
    label: 'TTS',
    description:
      'A plugin for text-to-speech(TTS) generation using the FAL.ai API within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-nft-generation': {
    category: 1,
    label: 'NFT Generation',
    description:
      'NFT collection generation plugin for Eliza OS that enables NFT creation, collection management, and verification on the Solana blockchain.',
    icon: '',
  },
  '@elizaos/plugin-video-generation': {
    category: 1,
    label: 'Video Generation',
    description:
      'A plugin for AI-powered video generation using Luma AI, providing automated video creation capabilities from text prompts.',
    icon: '',
  },
  '@elizaos/plugin-gitbook': {
    category: 1,
    label: 'GitBook',
    description:
      'A plugin for querying and retrieving information from GitBook documentation within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-udio': {
    category: 1,
    label: 'Udio',
    description:
      'Enables AI-powered music generation with capabilities for creating and extending audio from text prompts.',
    icon: '',
  },
  '@elizaos/plugin-suno': {
    category: 1,
    label: 'Suno',
    description:
      "Integrates Suno AI's music generation for creating custom music from text prompts with detailed controls.",
    icon: '',
  },
  '@elizaos/plugin-nft-collections': {
    category: 1,
    label: 'NFT Collections',
    description:
      'Integrates NFT data services for comprehensive market analytics and trading with support for 420+ verified collections.',
    icon: '',
  },
  '@elizaos/plugin-imgflip': {
    category: 1,
    label: 'Imgflip',
    description:
      'Generates memes using the imgflip.com API based on user messages.',
    icon: '',
  },
  '@elizaos/plugin-speech-tts': {
    category: 1,
    label: 'Speech TTS',
    description: 'TTS transcription service with OpenAI + ElevenLabs.',
    icon: '',
  },
  '@elizaos/plugin-letzai': {
    category: 1,
    label: 'LetzAI',
    description:
      'A plugin for integrating LetzAI Image Generation capabilities into the elizaos ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-video': {
    category: 1,
    label: 'Video',
    description:
      'The VideoService provides comprehensive video processing capabilities.',
    icon: '',
  },
  '@elizaos/plugin-pdf': {
    category: 1,
    label: 'PDF',
    description:
      'Core Node.js plugin for Eliza OS that provides essential services and actions for file operations.',
    icon: '',
  },
  '@elizaos/plugin-image': {
    category: 1,
    label: 'Image',
    description:
      'Processes and analyzes images to generate descriptions. Supports multiple providers.',
    icon: '',
  },

  // Development & Platform
  '@elizaos/plugin-bootstrap': {
    category: 2,
    label: 'Bootstrap',
    description:
      'A plugin providing core functionality and basic actions for ElizaOS agents.',
    icon: '',
  },
  '@elizaos/plugin-tee-log': {
    category: 2,
    label: 'TEE Log',
    description:
      'The TEE Log Plugin is designed to enhance the logging capabilities of the Eliza by providing a structured way to generate, store and verify TEE logs for agents.',
    icon: '',
  },
  '@elizaos/plugin-tee-marlin': {
    category: 2,
    label: 'Marlin TEE',
    description:
      'A plugin for making agents on Eliza verifiable through the use of Trusted Execution Environments',
    icon: '',
  },
  '@elizaos/plugin-goplus': {
    category: 2,
    label: 'GoPlus',
    description:
      'A plugin that enables on-chain security checks through the GoPlus API integration.',
    icon: '',
  },
  '@elizaos/plugin-opacity': {
    category: 2,
    label: 'Opacity',
    description:
      'This adapter integrates Opacity proofs into ElizaOS, enabling verifiable inference results from various AI model providers available through the CloudFlare AI Gateway.',
    icon: '',
  },
  '@elizaos/plugin-goat': {
    category: 2,
    label: 'GOAT',
    description:
      'A plugin for integrating blockchain capabilities through the GOAT (Great Onchain Agent Toolkit) framework within the ElizaOS ecosystem.',
    icon: '',
  },
  '@elizaos/plugin-intiface': {
    category: 2,
    label: 'Intiface',
    description:
      'Intiface/Buttplug.io integration plugin for Eliza OS that enables control of intimate hardware devices.',
    icon: '',
  },
  '@elizaos/plugin-node': {
    category: 2,
    label: 'Node',
    description:
      'Core Node.js plugin for Eliza OS that provides essential services and actions for file operations, media processing, and cloud integrations.',
    icon: '',
  },
  '@elizaos/plugin-tee': {
    category: 2,
    label: 'TEE',
    description:
      'A plugin for handling Trusted Execution Environment (TEE) operations, providing secure key derivation and remote attestation capabilities.',
    icon: '',
  },
  '@elizaos/plugin-trustdb': {
    category: 2,
    label: 'TrustDB',
    description:
      'A plugin for managing trust scores and performance metrics in a secure database, providing recommender tracking and token performance analysis capabilities.',
    icon: '',
  },
  '@elizaos/plugin-hyperbolic': {
    category: 2,
    label: 'Hyperbolic',
    description:
      'A powerful plugin for managing GPU instances on the Hyperbolic platform through Eliza AI.',
    icon: '',
  },
  '@elizaos/plugin-tee-verifiable-log': {
    category: 2,
    label: 'TEE Verifiable Log',
    description:
      'Implements a verifiable logging system within Trusted Execution Environments for secure, auditable records.',
    icon: '',
  },
  '@elizaos/plugin-openai': {
    category: 2,
    label: 'OpenAI',
    description:
      "Integrates OpenAI's GPT models for automated text generation with customizable prompts.",
    icon: '',
  },
  '@elizaos/plugin-nvidia-nim': {
    category: 2,
    label: 'NVIDIA NIM',
    description:
      "Integrates NVIDIA's AI foundation models for content analysis including AI image detection and safety checks.",
    icon: '',
  },
  '@elizaos/plugin-mind-network': {
    category: 2,
    label: 'Mind Network',
    description:
      'Integrates with Mind Network Hubs for secure, privacy-preserving voting using Fully Homomorphic Encryption.',
    icon: '',
  },
  '@elizaos/plugin-lit': {
    category: 2,
    label: 'Lit',
    description:
      'Integrates Lit Protocol for secure and decentralized access control and cryptographic operations.',
    icon: '',
  },
  '@elizaos/plugin-gitcoin-passport': {
    category: 2,
    label: 'Gitcoin Passport',
    description:
      'Interacts with Gitcoin Passport API for verifying and managing digital identity credentials.',
    icon: '',
  },
  '@elizaos/plugin-dkg': {
    category: 2,
    label: 'DKG',
    description:
      'Enables integration with OriginTrail Decentralized Knowledge Graph for enhanced search capabilities.',
    icon: '',
  },
  '@elizaos/plugin-devin': {
    category: 2,
    label: 'Devin',
    description:
      'Provides integration with Devin API for automated engineering assistance and session management.',
    icon: '',
  },
  '@elizaos/plugin-dcap': {
    category: 2,
    label: 'DCAP',
    description:
      'A plugin for verifying DCAP attestation on-chain, supporting both TDX and SGX environments.',
    icon: '',
  },
  '@elizaos/plugin-bittensor': {
    category: 2,
    label: 'Bittensor',
    description:
      "Integrates BitMind's API for accessing AI services on the Bittensor network, especially deepfake detection.",
    icon: '',
  },
  '@elizaos/plugin-agentkit': {
    category: 2,
    label: 'AgentKit',
    description:
      'Integrates CDP AgentKit tools for NFT and token management on various blockchain networks.',
    icon: '',
  },
  '@elizaos/plugin-sgx': {
    category: 2,
    label: 'SGX',
    description:
      'The SGX Plugin provides Intel SGX attestation capabilities to enhance security by creating trusted execution environments.',
    icon: '',
  },
  '@elizaos/plugin-irys': {
    category: 2,
    label: 'Irys',
    description:
      'A plugin that integrates Irys for decentralized data storage and retrieval, enabling multi-agent collaboration.',
    icon: '',
  },
  '@elizaos/plugin-llama': {
    category: 2,
    label: 'LLaMA',
    description:
      'Core LLaMA plugin for Eliza OS that provides local Large Language Model capabilities.',
    icon: '',
  },
  '@elizaos/plugin-browser': {
    category: 2,
    label: 'Browser',
    description: 'Web scraping and content extraction with Playwright.',
    icon: '',
  },
  '@elizaos/plugin-aws-s3': {
    category: 2,
    label: 'AWS S3',
    description:
      'Provides AWS S3 integration for cloud-based file operations and storage management.',
    icon: '',
  },
  '@elizaos/plugin-primus': {
    category: 2,
    label: 'Primus',
    description:
      'Core plugin for Eliza OS that provides essential platform services.',
    icon: '',
  },
  '@elizaos/plugin-di': {
    category: 2,
    label: 'DI',
    description:
      'Dependency Injection plugin for Eliza OS that provides core functionality.',
    icon: '',
  },

  // Integration & Services
  '@elizaos/plugin-web-search': {
    category: 3,
    label: 'Web Search',
    description:
      'A plugin for powerful web search capabilities, providing efficient search query handling and result processing through a customizable API interface.',
    icon: '',
  },
  '@elizaos/plugin-echochambers': {
    category: 3,
    label: 'EchoChambers',
    description:
      'The EchoChambers plugin enables ELIZA to interact in chat rooms, providing conversational capabilities with dynamic interaction handling.',
    icon: '',
  },
  '@elizaos/plugin-open-weather': {
    category: 3,
    label: 'OpenWeather',
    description:
      'A plugin for Eliza that enables weather checking using the OpenWeather API.',
    icon: '',
  },
  '@elizaos/plugin-giphy': {
    category: 3,
    label: 'Giphy',
    description: 'A plugin for sending GIFs in response to user messages.',
    icon: '',
  },
  '@elizaos/plugin-whatsapp': {
    category: 3,
    label: 'WhatsApp',
    description:
      'A plugin for integrating WhatsApp Cloud API with your application, providing comprehensive messaging capabilities and webhook handling.',
    icon: '',
  },
  '@elizaos/plugin-twitter': {
    category: 3,
    label: 'Twitter',
    description:
      'A plugin for Twitter/X integration, providing automated tweet posting capabilities with character-aware content generation.',
    icon: '',
  },
  '@elizaos/plugin-news': {
    category: 3,
    label: 'News',
    description:
      'A plugin for fetching and handling real-time news data through NewsAPI integration.',
    icon: '',
  },
  '@elizaos/plugin-football': {
    category: 3,
    label: 'Football',
    description:
      'Provides live football match data and league standings information through the Football-Data.org API.',
    icon: '',
  },
  '@elizaos/plugin-email-automation': {
    category: 3,
    label: 'Email Automation',
    description:
      'AI-powered email automation plugin for Eliza that intelligently detects email-worthy conversations and handles generation/delivery.',
    icon: '',
  },
  '@elizaos/plugin-email': {
    category: 3,
    label: 'Email',
    description:
      'Implements email client functionality for sending and receiving emails through SMTP/IMAP services.',
    icon: '',
  },
};

export const SECRETS_PLUGIN_MAP: Record<Plugin, Record<string, string>> = {
  '@elizaos/plugin-0g': {
    ZEROG_INDEXER_RPC: '',
    ZEROG_EVM_RPC: '',
    ZEROG_PRIVATE_KEY: '',
    ZEROG_FLOW_ADDRESS: '',
  },
  '@elizaos/plugin-abstract': {
    ABSTRACT_ADDRESS: '',
    ABSTRACT_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-aptos': {
    APTOS_PRIVATE_KEY: '',
    APTOS_NETWORK: '',
  },
  '@elizaos/plugin-avalanche': {
    AVALANCHE_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-binance': {
    BINANCE_API_KEY: '',
    BINANCE_SECRET_KEY: '',
  },
  '@elizaos/plugin-coinbase': {
    COINBASE_API_KEY: '',
    COINBASE_PRIVATE_KEY: '',
    COINBASE_COMMERCE_KEY: '',
    COINBASE_NOTIFICATION_URI: '',
  },
  '@elizaos/plugin-coingecko': {
    COINGECKO_API_KEY: '',
    COINGECKO_PRO_API_KEY: '',
  },
  '@elizaos/plugin-allora': {
    ALLORA_API_KEY: '',
  },
  '@elizaos/plugin-anyone': {},
  '@elizaos/plugin-arthera': {
    ARTHERA_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-asterai': {
    ASTERAI_AGENT_ID: '',
    ASTERAI_PUBLIC_QUERY_KEY: '',
  },
  '@elizaos/plugin-autonome': {
    AUTONOME_JWT_TOKEN: '',
    AUTONOME_RPC: '',
  },
  '@elizaos/plugin-avail': {
    AVAIL_ADDRESS: '',
    AVAIL_SEED: '',
  },
  '@elizaos/plugin-depin': {
    SENTAI_API_KEY: '',
  },
  '@elizaos/plugin-genlayer': {
    GENLAYER_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-spheron': {
    PRIVATE_KEY: '',
    PROVIDER_PROXY_URL: '',
    WALLET_ADDRESS: '',
  },
  '@elizaos/plugin-akash': {
    AKASH_ENV: 'mainnet',
    AKASH_NET: 'https://raw.githubusercontent.com/ovrclk/net/master/mainnet',
    RPC_ENDPOINT: 'https://rpc.akashnet.net:443',
    AKASH_GAS_PRICES: '0.025uakt',
    AKASH_GAS_ADJUSTMENT: '1.5',
    AKASH_KEYRING_BACKEND: 'os',
    AKASH_FROM: 'default',
    AKASH_FEES: '20000uakt',
    AKASH_MNEMONIC: '',
    AKASH_MANIFEST_MODE: 'auto',
    AKASH_MANIFEST_VALIDATION_LEVEL: 'strict',
    AKASH_MANIFEST_PATH: '/path/to/manifests',
    AKASH_DEPOSIT: '5000000uakt',
    AKASH_SDL: 'deployment.yml',
  },
  '@elizaos/plugin-coinmarketcap': {
    COINMARKETCAP_API_KEY: '',
  },
  '@elizaos/plugin-conflux': {
    CONFLUX_CORE_PRIVATE_KEY: '',
    CONFLUX_CORE_SPACE_RPC_URL: '',
    CONFLUX_MEME_CONTRACT_ADDRESS: '',
  },
  '@elizaos/plugin-cosmos': {
    COSMOS_RECOVERY_PHRASE: '',
    COSMOS_AVAILABLE_CHAINS: '',
  },
  '@elizaos/plugin-cronoszkevm': {
    CRONOSZKEVM_ADDRESS: '',
    CRONOSZKEVM_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-evm': {
    EVM_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-flow': {
    FLOW_ADDRESS: '',
    FLOW_PRIVATE_KEY: '',
    FLOW_NETWORK: '',
    FLOW_ENDPOINT_URL: '',
  },
  '@elizaos/plugin-fuel': {
    FUEL_PRIVATE_KEY: '',
    FUEL_PROVIDER_URL: '',
  },
  '@elizaos/plugin-icp': {
    INTERNET_COMPUTER_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-hyperliquid': {
    HYPERLIQUID_PRIVATE_KEY: '',
    HYPERLIQUID_TESTNET: 'false',
  },
  '@elizaos/plugin-multiversx': {
    MVX_PRIVATE_KEY: '',
    MVX_NETWORK: '',
  },
  '@elizaos/plugin-near': {
    NEAR_WALLET_SECRET_KEY: '',
    NEAR_WALLET_PUBLIC_KEY: '',
    NEAR_ADDRESS: '',
    NEAR_NETWORK: '',
    NEAR_RPC_URL: '',
    NEAR_SLIPPAGE: '',
  },
  '@elizaos/plugin-rabbi-trader': {
    WALLET_PRIVATE_KEY: '',
    WALLET_PUBLIC_KEY: '',
    BIRDEYE_API_KEY: '',
    TWITTER_ENABLED: '',
    TWITTER_USERNAME: '',
    DEXSCREENER_WATCHLIST_ID: '',
    COINGECKO_API_KEY: '',
  },
  '@elizaos/plugin-solana': {
    WALLET_SECRET_KEY: '',
    WALLET_PUBLIC_KEY: '',
    SOL_ADDRESS: '',
    SLIPPAGE: '',
    SOLANA_RPC_URL: '',
    HELIUS_API_KEY: '',
    BIRDEYE_API_KEY: '',
  },
  '@elizaos/plugin-starknet': {
    STARKNET_ADDRESS: '',
    STARKNET_PRIVATE_KEY: '',
    STARKNET_RPC_URL: '',
  },
  '@elizaos/plugin-story': {
    STORY_PRIVATE_KEY: '',
    STORY_API_BASE_URL: '',
    STORY_API_KEY: '',
    PINATA_JWT: '',
  },
  '@elizaos/plugin-sui': {
    SUI_PRIVATE_KEY: '',
    SUI_NETWORK: '',
  },
  '@elizaos/plugin-ton': {
    TON_PRIVATE_KEY: '',
    TON_RPC_URL: '',
  },
  '@elizaos/plugin-zksync-era': {
    ZKSYNC_ADDRESS: '',
    ZKSYNC_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-image-generation': {
    IMAGE_STORAGE_BUCKET: '',
    STORAGE_ACCESS_KEY: '',
    STORAGE_SECRET_KEY: '',
  },
  '@elizaos/plugin-3d-generation': {
    FAL_API_KEY: '',
  },
  '@elizaos/plugin-tts': {
    FAL_API_KEY: '',
  },
  '@elizaos/plugin-nft-generation': {
    RESERVOIR_API_KEY: '',
  },
  '@elizaos/plugin-video-generation': {
    LUMA_API_KEY: '',
  },
  '@elizaos/plugin-obsidian': {
    OBSIDIAN_API_TOKEN: '',
  },
  '@elizaos/plugin-bootstrap': {},
  '@elizaos/plugin-gitbook': {
    GITBOOK_SPACE_ID: '',
  },
  '@elizaos/plugin-goat': {
    EVM_PRIVATE_KEY: '',
    EVM_PROVIDER_URL: '',
  },
  '@elizaos/plugin-intiface': {
    INTIFACE_URL: '',
    INTIFACE_NAME: '',
    DEVICE_NAME: '',
  },
  '@elizaos/plugin-node': {},
  '@elizaos/plugin-tee': {
    TEE_MODE: '',
    WALLET_SECRET_SALT: '',
  },
  '@elizaos/plugin-trustdb': {},
  '@elizaos/plugin-echochambers': {},
  '@elizaos/plugin-web-search': {
    TAVILY_API_KEY: '',
  },
  '@elizaos/plugin-whatsapp': {
    WHATSAPP_ACCESS_TOKEN: '',
    WHATSAPP_PHONE_NUMBER_ID: '',
  },
  '@elizaos/plugin-twitter': {
    TWITTER_USERNAME: '',
    TWITTER_PASSWORD: '',
  },
  '@elizaos/plugin-tee-log': {
    TEE_LOG_ENABLED: 'true',
  },
  '@elizaos/plugin-goplus': {
    GOPLUS_API_KEY: 'true',
  },
  '@elizaos/plugin-opacity': {
    OPACITY_TEAM_ID: '',
    OPACITY_CLOUDFLARE_NAME: '',
    OPACITY_PROVER_URL: '',
    VERIFIABLE_INFERENCE_ENABLED: '',
    VERIFIABLE_INFERENCE_PROVIDER: '',
  },
  '@elizaos/plugin-open-weather': {
    OPEN_WEATHER_API_KEY: '',
  },
  '@elizaos/plugin-giphy': {
    GIPHY_API_KEY: '',
  },
  '@elizaos/plugin-tee-marlin': {
    TEE_MARLIN: 'yes',
  },
  '@elizaos/plugin-solana-agentkit': {
    SOLANA_PRIVATE_KEY: '',
    SOLANA_RPC_URL: '',
  },
  '@elizaos/plugin-movement': {
    MOVEMENT_PRIVATE_KEY: '',
    MOVEMENT_NETWORK: '',
  },
  '@elizaos/plugin-quai': {
    QUAI_PRIVATE_KEY: '',
    QUAI_RPC_URL: '',
  },
  '@elizaos/plugin-trikon': {
    TRIKON_WALLET_ADDRESS: '',
    TRIKON_INITIAL_BALANCE: '',
  },
  '@elizaos/plugin-pyth-data': {
    PYTH_NETWORK_ENV: '',
    PYTH_MAX_RETRIES: '',
    PYTH_RETRY_DELAY: '',
    PYTH_LOG_LEVEL: '',
    PYTH_MAX_PRICE_STREAMS: '',
  },
  '@elizaos/plugin-massa': {
    MASSA_PRIVATE_KEY: '',
    MASSA_RPC_URL: '',
  },
  '@elizaos/plugin-injective': {
    INJECTIVE_NETWORK: '',
    INJECTIVE_PRIVATE_KEY: '',
    EVM_PUBLIC_KEY: '',
    INJECTIVE_PUBLIC_KEY: '',
  },
  '@elizaos/plugin-hyperbolic': {
    HYPERBOLIC_API_KEY: '',
    HYPERBOLIC_ENV: '',
    HYPERBOLIC_GRANULAR_LOG: '',
    HYPERBOLIC_LOG_LEVEL: '',
    HYPERBOLIC_SPASH: '',
  },
  '@elizaos/plugin-arbitrage': {
    EVM_PRIVATE_KEY: '',
    FLASHBOTS_RELAY_SIGNING_KEY: '',
    BUNDLE_EXECUTOR_ADDRESS: '',
  },
  '@elizaos/plugin-ferepro': {
    FEREAI_USER_ID: '',
    FEREAI_API_KEY: '',
    REQUEST_TIMEOUT: '',
  },
  '@elizaos/plugin-holdstation': {
    HOLDSTATION_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-zilliqa': {
    EVM_PRIVATE_KEY: '',
    EVM_PROVIDER_URL: '',
    ENABLE_ZILLIQA: '1',
  },
  '@elizaos/plugin-zerion': {
    ZERION_API_KEY: '',
  },
  '@elizaos/plugin-udio': {
    UDIO_AUTH_TOKEN: '',
  },
  '@elizaos/plugin-tee-verifiable-log': {
    TEE_MODE: '',
    WALLET_SECRET_SALT: '',
    VLOG: '',
  },
  '@elizaos/plugin-suno': {
    SUNO_API_KEY: '',
  },
  '@elizaos/plugin-squid-router': {
    SQUID_SDK_URL: '',
    SQUID_INTEGRATOR_ID: '',
    SQUID_EVM_ADDRESS: '',
    SQUID_EVM_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-solana-v2': {
    SOLANA_PRIVATE_KEY: '',
    SOLANA_PUBLIC_KEY: '',
    SOLANA_RPC_URL: '',
    OPENAI_API_KEY: '',
  },
  '@elizaos/plugin-sei': {
    SEI_PRIVATE_KEY: '',
    SEI_NETWORK: '',
  },
  '@elizaos/plugin-quick-intel': {
    QUICKINTEL_API_KEY: '',
  },
  '@elizaos/plugin-openai': {
    OPENAI_API_KEY: '',
  },
  '@elizaos/plugin-omniflix': {
    OMNIFLIX_RPC_ENDPOINT: '',
    OMNIFLIX_API_URL: '',
    OMNIFLIX_MNEMONIC: '',
    OMNIFLIX_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-nvidia-nim': {
    NVIDIA_NIM_ENV: '',
    NVIDIA_NIM_SPASH: '',
    NVIDIA_NIM_API_KEY: '',
    NVIDIA_NGC_API_KEY: '',
    NVIDIA_NIM_MAX_RETRIES: '',
    NVIDIA_NIM_RETRY_DELAY: '',
    NVIDIA_NIM_TIMEOUT: '',
    NVIDIA_GRANULAR_LOG: '',
    NVIDIA_LOG_LEVEL: '',
    NVIDIA_OFFTOPIC_SYSTEM: '',
    NVIDIA_OFFTOPIC_USER: '',
    NVIDIA_NIM_BASE_VISION_URL: '',
    NVIDIA_COSMOS_MODEL: '',
    NVIDIA_COSMOS_INVOKE_URL: '',
    NVIDIA_COSMOS_ASSET_URL: '',
    NVIDIA_COSMOS_MAX_TOKENS: '',
  },
  '@elizaos/plugin-nft-collections': {
    RESERVOIR_API_KEY: '',
    NANSEN_API_KEY: '',
    DUNE_API_KEY: '',
    ALCHEMY_API_KEY: '',
    CHAINBASE_API_KEY: '',
    NFTSCAN_API_KEY: '',
    TWITTER_API_KEY: '',
    DISCORD_API_KEY: '',
    TELEGRAM_API_KEY: '',
  },
  '@elizaos/plugin-news': {
    NEWS_API_KEY: '',
  },
  '@elizaos/plugin-moralis': {
    MORALIS_API_KEY: '',
  },
  '@elizaos/plugin-mind-network': {
    MIND_HOT_WALLET_PRIVATE_KEY: '',
    MIND_COLD_WALLET_ADDRESS: '',
  },
  '@elizaos/plugin-mina': {
    MINA_PRIVATE_KEY: '',
    MINA_NETWORK: '',
  },
  '@elizaos/plugin-lit': {
    EVM_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-lightning': {
    LND_TLS_CERT: '',
    LND_MACAROON: '',
    LND_SOCKET: '',
  },
  '@elizaos/plugin-iq6900': {
    IQ_WALLET_ADDRESS: '',
  },
  '@elizaos/plugin-initia': {
    INITIA_PRIVATE_KEY: '',
    INITIA_NODE_URL: '',
    INITIA_CHAIN_ID: '',
  },
  '@elizaos/plugin-imgflip': {
    IMGFLIP_USERNAME: '',
    IMGFLIP_PASSWORD: '',
  },
  '@elizaos/plugin-gitcoin-passport': {
    PASSPORT_API_KEY: '',
    PASSPORT_SCORER: '',
  },
  '@elizaos/plugin-gelato': {
    GELATO_RELAY_API_KEY: '',
    EVM_PROVIDER_URL: '',
    EVM_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-form': {
    FORM_PRIVATE_KEY: '',
    FORM_TESTNET: '',
  },
  '@elizaos/plugin-football': {
    FOOTBALL_API_KEY: '',
  },
  '@elizaos/plugin-ethstorage': {
    ETHSTORAGE_ADDRESS: '',
    ETHSTORAGE_RPC_URL: '',
    ETHSTORAGE_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-email-automation': {
    RESEND_API_KEY: '',
    DEFAULT_TO_EMAIL: '',
    DEFAULT_FROM_EMAIL: '',
    EMAIL_AUTOMATION_ENABLED: '',
    EMAIL_EVALUATION_PROMPT: '',
  },
  '@elizaos/plugin-email': {
    EMAIL_OUTGOING_SERVICE: '',
    EMAIL_OUTGOING_HOST: '',
    EMAIL_OUTGOING_PORT: '',
    EMAIL_SECURE: '',
    EMAIL_OUTGOING_USER: '',
    EMAIL_OUTGOING_PASS: '',
    EMAIL_INCOMING_SERVICE: '',
    EMAIL_INCOMING_HOST: '',
    EMAIL_INCOMING_PORT: '',
    EMAIL_INCOMING_USER: '',
    EMAIL_INCOMING_PASS: '',
  },
  '@elizaos/plugin-edwin': {
    EVM_PRIVATE_KEY: '',
    SOLANA_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-dkg': {
    NODE_INFORMATION: '',
    LLM_KEY: '',
    TWITTER_CREDENTIALS: '',
  },
  '@elizaos/plugin-dexscreener': {},
  '@elizaos/plugin-devin': {
    DEVIN_API_TOKEN: '',
  },
  '@elizaos/plugin-desk-exchange': {
    DESK_EXCHANGE_PRIVATE_KEY: '',
    DESK_EXCHANGE_NETWORK: '',
  },
  '@elizaos/plugin-dcap': {
    EVM_PRIVATE_KEY: '',
    DCAP_MODE: '',
  },
  '@elizaos/plugin-cronos': {
    CRONOS_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-chainbase': {
    CHAINBASE_API_KEY: '',
  },
  '@elizaos/plugin-bnb': {
    BNB_PRIVATE_KEY: '',
    BNB_PUBLIC_KEY: '',
    BSC_PROVIDER_URL: '',
    OPBNB_PROVIDER_URL: '',
  },
  '@elizaos/plugin-bittensor': {
    BITMIND: '',
  },
  '@elizaos/plugin-b2': {
    B2_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-ankr': {
    ANKR_ENV: '',
    ANKR_WALLET: '',
    ANKR_MAX_RETRIES: '',
    ANKR_RETRY_DELAY: '',
    ANKR_TIMEOUT: '',
    ANKR_LOG_LEVEL: '',
  },
  '@elizaos/plugin-agentkit': {
    CDP_API_KEY_NAME: '',
    CDP_API_KEY_PRIVATE_KEY: '',
    CDP_AGENT_KIT_NETWORK: '',
  },
  '@elizaos/plugin-0x': {
    WALLET_PRIVATE_KEY: '',
    ZERO_EX_API_KEY: '',
    BLAST_RPC_URL: '',
    SCROLL_RPC_URL: '',
    LINEA_RPC_URL: '',
    AVALANCHE_RPC_URL: '',
    ARBITRUM_RPC_URL: '',
    BASE_RPC_URL: '',
    POLYGON_RPC_URL: '',
    BSC_RPC_URL: '',
    OPTIMISM_RPC_URL: '',
    ETH_RPC_URL: '',
  },
  '@elizaos/plugin-router-nitro': {
    ROUTER_NITRO_EVM_PRIVATE_KEY: '',
    ROUTER_NITRO_EVM_ADDRESS: '',
  },
  '@elizaos/plugin-speech-tts': {
    OPENAI_API_KEY: '',
    OPENAI_API_URL: '',
    ELEVENLABS_XI_API_URL: '',
    ELEVENLABS_XI_API_KEY: '',
    ELEVENLABS_MODEL_ID: '',
    ELEVENLABS_VOICE_ID: '',
    ELEVENLABS_VOICE_STABILITY: '',
    ELEVENLABS_VOICE_SIMILARITY_BOOST: '',
    ELEVENLABS_VOICE_STYLE: '',
    ELEVENLABS_VOICE_USE_SPEAKER_BOOST: '',
    ELEVENLABS_OPTIMIZE_STREAMING_LATENCY: '',
    ELEVENLABS_OUTPUT_FORMAT: '',
    VITS_VOICE: '',
    VITS_MODEL: '',
  },
  '@elizaos/plugin-thirdweb': {
    THIRDWEB_SECRET_KEY: '',
  },
  '@elizaos/plugin-stargaze': {
    STARGAZE_ENDPOINT: '',
  },
  '@elizaos/plugin-sgx': {},
  '@elizaos/plugin-letzai': {
    LETZAI_API_KEY: '',
  },
  '@elizaos/plugin-irys': {
    EVM_WALLET_PRIVATE_KEY: '',
    AGENTS_WALLET_PUBLIC_KEYS: '',
  },
  '@elizaos/plugin-apro': {
    APRO_RPC_URL: '',
    APRO_PROXY_ADDRESS: '',
    APRO_PRIVATE_KEY: '',
    APRO_CONVERTER_ADDRESS: '',
    APRO_AUTO_HASH_DATA: '',
  },
  '@elizaos/plugin-lens-network': {
    LENS_ADDRESS: '',
    LENS_PRIVATE_KEY: '',
  },
  '@elizaos/plugin-llama': {
    LLAMA_LOCAL_PATH: '',
    LLAMA_MODEL: '',
  },
  '@elizaos/plugin-video': {},
  '@elizaos/plugin-pdf': {},
  '@elizaos/plugin-image': {
    OPENAI_API_KEY: '',
    GOOGLE_GENERATIVE_AI_API_KEY: '',
  },
  '@elizaos/plugin-browser': {
    CAPSOLVER_API_KEY: '',
  },
  '@elizaos/plugin-aws-s3': {
    AWS_ACCESS_KEY_ID: '',
    AWS_SECRET_ACCESS_KEY: '',
    AWS_REGION: '',
    AWS_S3_BUCKET: '',
    AWS_S3_UPLOAD_PATH: '',
    AWS_S3_ENDPOINT: '',
    AWS_S3_SSL_ENABLED: '',
    AWS_S3_FORCE_PATH_STYLE: '',
  },
  '@elizaos/plugin-primus': {
    PRIMUS_APP_ID: '',
    PRIMUS_APP_SECRET: '',
    VERIFIABLE_INFERENCE_ENABLED: '',
    VERIFIABLE_INFERENCE_PROVIDER: '',
  },
  '@elizaos/plugin-di': {},
};
